import { PaginationResponse } from '@repo/ui/data-table'

import { EnrollmentCharacteristic } from '../../lib/types/models/enrollment-characteristics/enrollment-characteristics'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentCharacteristics() {
  return restApiClient
    .url(constructApiUrl(API.enrollmentCharacteristics.getAll.url, null))
    .get<PaginationResponse<EnrollmentCharacteristic>>()
}
